import axiosService from "services/axios.service";

const API_URL = process.env.REACT_APP_URL_API;

const BASE_API_URL = `${API_URL}/v1/admin`;

export const getAccounting = async (
  payload: any,
  resource: any
): Promise<any> => {
  const response = await axiosService.post(
    `${BASE_API_URL}/${resource}`,
    payload
  );
  return response?.data;
};

export const getAccountingforContributor = async (
  payload: any,
  resource: any,
  sort: string,
  mixinitOnly?: "true" | "false"
): Promise<any> => {
  const hasSort = Boolean(sort);
  const hasMixinit = mixinitOnly === "true" || mixinitOnly === "false";
  const query = `${hasSort ? `?${sort}` : ""}${
    hasMixinit ? `${hasSort ? "&" : "?"}mixinitOnly=${mixinitOnly}` : ""
  }`;
  const response = await axiosService.post(
    `${BASE_API_URL}/${resource}/contributors${query}`,
    payload
  );
  return response?.data;
};

export const getTracksUploadedByLabelContributor = async (
  payload: any
): Promise<any> => {
  const response = await axiosService.post(
    `${BASE_API_URL}/tracks/uploads/by-label-contributor`,
    payload
  );
  return response?.data;
};

export const getTracksSoldByLabelContributor = async (
  payload: any
): Promise<any> => {
  const response = await axiosService.post(
    `${BASE_API_URL}/track-purchases/sold/by-label-contributor`,
    payload
  );
  return response?.data;
};

export const getTrackDetailSoldByLabelContributor = async (
  payload: any
): Promise<any> => {
  const response = await axiosService.post(
    `${BASE_API_URL}/track-purchases/detail/by-label-contributor`,
    payload
  );
  return response?.data;
};

export const updateNumberUploads = async (payload: any): Promise<any> => {
  const { accountingPeriodId, uploads } = payload;
  const response = await axiosService.put(
    `${BASE_API_URL}/accounting/contributors/${accountingPeriodId}`,
    { uploads }
  );
  return response?.data;
};

export const changeAllProcessPayout = async (payload: any): Promise<any> => {
  const { accountingPeriodId, uploads } = payload;
  const response = await axiosService.put(
    `${BASE_API_URL}/accounting/contributors/${accountingPeriodId}`,
    { uploads }
  );
  return response?.data;
};
